module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-collector-2.282e0228.svg";